export default __webpack_public_path__ + "static/digital-transform-banner-44e8bfdb003a0fcaec5af460718e1f8b.png";